import { News } from '@/modules/news/types';
import { all_roles } from '@/utils';

const access_roles = {
  [News.Pages.NEWS]: all_roles,
  [News.Pages.NEWS_DETAIL]: all_roles,
};

export default access_roles;
